import { createQueryKeys } from '@lukemorales/query-key-factory';

export const staffLink = createQueryKeys('staffLink', {
  user: (userId: string) => [userId],
});
